var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangleExclamationSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99942 0C8.4432 0 8.85261 0.234375 9.07762 0.61875L15.8281 12.1187C16.0562 12.5062 16.0562 12.9844 15.8344 13.3719C15.6125 13.7594 15.1968 14 14.7499 14H1.24894C0.802029 14 0.386374 13.7594 0.164483 13.3719C-0.0574075 12.9844 -0.0542823 12.5031 0.170734 12.1187L6.92122 0.61875C7.14623 0.234375 7.55564 0 7.99942 0ZM7.99942 4C7.58377 4 7.24937 4.33437 7.24937 4.75V8.25C7.24937 8.66562 7.58377 9 7.99942 9C8.41507 9 8.74947 8.66562 8.74947 8.25V4.75C8.74947 4.33437 8.41507 4 7.99942 4ZM8.99949 11C8.99949 10.4469 8.55258 10 7.99942 10C7.44625 10 6.99935 10.4469 6.99935 11C6.99935 11.5531 7.44625 12 7.99942 12C8.55258 12 8.99949 11.5531 8.99949 11Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclamationSolid);
export default __webpack_public_path__ + "static/media/triangle-exclamation-solid.32d6976a14a790e681e69e5789451426.svg";
export { ForwardRef as ReactComponent };